export const Back = "Back";
export const EnterFullScreen = "Enter full-screen mode";
export const ExitFullScreen = "Exit full-screen mode";
export const Filter = "Filter";
